import { Element, Node } from 'slate';
import { defaultParagraph } from 'slate/extensions/paragraph';
import { LayoutElement } from 'slate/types/slate';

export const isLayout = (node: Node): node is LayoutElement => Element.isElement(node) && node.type === 'layout';

export const emptyLayout = (opts?: { horizontal?: boolean; withParagraph?: boolean }): LayoutElement => {
  const horizontal = opts?.horizontal ?? false;
  const withParagraph = opts?.withParagraph ?? true;

  return {
    type: 'layout',
    className: `layout ${horizontal ? 'horizontal' : 'vertical'}`,
    children: withParagraph ? [defaultParagraph()] : [],
  };
};
